import React from 'react';
import { Typography } from '@mui/material';
import { UserRoleItem } from '../../interfaces';

interface Props {
  selectedRole: string | undefined;
  possibleRoles: UserRoleItem[];
}

const RoleDescription = ({ selectedRole, possibleRoles }: Props) => (
  <Typography variant="body2">{possibleRoles.find(item => item.name === selectedRole)?.description}</Typography>
);

export default RoleDescription;
